import React, { useEffect, useState, useCallback } from 'react';
import { 
    Button, 
    FormControlLabel,
    Switch,
    Typography,
    Avatar,
    Chip,
    Box
} from '@mui/material';
import Modal from 'react-bootstrap/Modal';
import Paper from '@mui/material/Paper';
import CardContent from '@mui/material/CardContent';
import { 
    FaBuilding, 
    FaCheckCircle, 
    FaClock, 
    FaTimesCircle,
    FaRecycle 
} from 'react-icons/fa';
import nest from '../../../services/nest';
import { getUserId } from '../../../services/auth';
import Loading from '../../../components/Loading';

function ModalEditarContratos({ 
    modalEditarContratosVisible, 
    setModalEditarContratosVisible, 
    idUsuarioDependente, 
    loadOutrosUsuariosAbaixo,
    arrayIdsContratos = [],
    setAlerta 
}) {
    const [loading, setLoading] = useState(false);
    const [list, setList] = useState([]);
    const [isEnabled, setIsEnabled] = useState([]);

    const toggleSwitch = (id) => {
        const numId = Number(id);
        setIsEnabled(prevState => {
            return prevState.map(item =>
                Number(item.id) === numId ? { ...item, enabled: !item.enabled } : item
            );
        });
    };

    const getContracts = useCallback(async () => {
        let arrayObjetos = [];
        setLoading(true);
        
        try {
            const id_usuario_cliente = await getUserId();
            const response = await nest.get(`/clientes/PorUsuario`, {
                params: {
                    cliente_usuario_id: id_usuario_cliente
                }
            });
            
            setLoading(false);
            let dataTemp = response.data;
            
            if (dataTemp != null) {
                setList(dataTemp);
                dataTemp.forEach(elemento => {
                    // Garantir que os IDs sejam comparados como números
                    const elementoId = Number(elemento.id);
                    const isContratoSelecionado = arrayIdsContratos.some(contratoId => Number(contratoId) === elementoId);
                    
                    if (isContratoSelecionado) {
                        arrayObjetos.push({ 
                            id: elementoId, 
                            cliente_id: elemento.cliente_id, 
                            enabled: true 
                        });
                    } else {
                        arrayObjetos.push({ 
                            id: elementoId, 
                            cliente_id: elemento.cliente_id, 
                            enabled: false 
                        });
                    }
                });
                setIsEnabled(arrayObjetos);
            }
        } catch (error) {
            console.log(error);
            setLoading(false);
            setAlerta({
                status: true,
                msg: 'Erro ao carregar contratos!',
                type: 'error'
            });
        }
    }, [arrayIdsContratos, setAlerta]);

    useEffect(() => {
        if (modalEditarContratosVisible) {
            getContracts();
        }
    }, [modalEditarContratosVisible, getContracts]);

    const handleSave = async () => {
        try {
            setLoading(true);
            let clienteUsuarioDependenteId = idUsuarioDependente;
            let arrayDeAcessos = [];
            
            for (const acesso of isEnabled) {
                if (acesso.enabled === true) {
                    const dados = {
                        cliente_id: acesso.cliente_id,
                        contrato_id: acesso.id,
                        cliente_usuario_id: clienteUsuarioDependenteId
                    };
                    arrayDeAcessos.push(dados);
                }
            }
            
            await nest.post('/cliente/cliente-acessos', arrayDeAcessos);
            
            setLoading(false);
            setModalEditarContratosVisible(false);
            loadOutrosUsuariosAbaixo();
            
            setAlerta({
                status: true,
                msg: 'Acessos cadastrados com sucesso!',
                type: 'success'
            });
        } catch (error) {
            console.error("Erro ao enviar os dados:", error);
            setLoading(false);
            
            if (error?.response) {
                switch (error.response.status) {
                    case 404:
                        setAlerta({
                            status: true,
                            msg: 'Problema nas informações de envio!',
                            type: 'error'
                        });
                        break;
                    case 409:
                        setAlerta({
                            status: true,
                            msg: 'Deve ter pelo menos um contrato no usuário!',
                            type: 'error'
                        });
                        break;
                    default:
                        setAlerta({
                            status: true,
                            msg: 'Erro no servidor, tente novamente mais tarde',
                            type: 'error'
                        });
                }
            } else {
                setAlerta({
                    status: true,
                    msg: 'Erro inesperado ao salvar acessos!',
                    type: 'error'
                });
            }
        }
    };

    const handleClose = () => {
        setModalEditarContratosVisible(false);
    };

    const getStatusIcon = (status) => {
        switch (status) {
            case "Contrato Ativo":
                return <FaCheckCircle color="#4caf50" size={24} />;
            case "Contrato Suspenso":
                return <FaClock color="#ff9800" size={24} />;
            default:
                return <FaTimesCircle color="#f44336" size={24} />;
        }
    };

    const getStatusColor = (status) => {
        switch (status) {
            case "Contrato Ativo":
                return "#4caf50";
            case "Contrato Suspenso":
                return "#ff9800";
            default:
                return "#f44336";
        }
    };

    const renderContractItem = (item, index) => {
        const { id, bairro, cnpj, endereco, status, nome, tiporesiduo } = item;
        // Garantir comparação correta dos IDs
        const itemId = Number(id);
        const isCardEnabled = isEnabled.some(obj => Number(obj.id) === itemId && obj.enabled);

        return (
            <div key={index} style={{ marginBottom: 15 }}>
                <Paper 
                    elevation={3} 
                    style={{
                        border: isCardEnabled ? '3px solid var(--main-bg-color)' : '1px solid #e0e0e0',
                        borderRadius: 8,
                        overflow: 'hidden'
                    }}
                >
                    <CardContent>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                            marginBottom: 15
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                <Avatar 
                                    sx={{ 
                                        backgroundColor: 'var(--main-bg-color)', 
                                        width: 40, 
                                        height: 40 
                                    }}
                                >
                                    <FaBuilding color="var(--main-white-color)" size={20} />
                                </Avatar>
                                <div>
                                    <Typography variant="h6" component="div" style={{ fontWeight: 'bold' }}>
                                        Contrato: {id}
                                    </Typography>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 5 }}>
                                        {getStatusIcon(status)}
                                        <Chip 
                                            label={status}
                                            size="small"
                                            style={{
                                                backgroundColor: getStatusColor(status),
                                                color: 'white',
                                                fontWeight: 'bold'
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                            
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={isCardEnabled}
                                        onChange={() => toggleSwitch(itemId)}
                                        color="primary"
                                    />
                                }
                                label=""
                                style={{ margin: 0 }}
                            />
                        </div>

                        <Box style={{ marginLeft: 50 }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                                <FaRecycle color="var(--main-bg-color)" size={16} />
                                <Typography variant="body2" color="text.secondary">
                                    <strong>Tipo:</strong> {tiporesiduo}
                                </Typography>
                            </div>
                            
                            <Typography variant="body2" color="text.secondary" style={{ marginBottom: 8 }}>
                                <strong>Nome:</strong> {nome} - {cnpj}
                            </Typography>
                            
                            <Typography variant="body2" color="text.secondary">
                                <strong>Endereço:</strong> {endereco} - {bairro}
                            </Typography>
                        </Box>
                    </CardContent>
                </Paper>
            </div>
        );
    };

    return (
        <Modal 
            show={modalEditarContratosVisible} 
            onHide={handleClose} 
            centered
            size="lg"
        >
            <Loading open={loading} />
            <Modal.Header closeButton style={{ paddingTop: 10, paddingBottom: 10 }}>
                <Modal.Title style={{
                    color: "var(--main-bg-color)",
                    width: "100%",
                    textAlign: 'center',
                }}>
                    Cadastrar contratos para o usuário
                </Modal.Title>
            </Modal.Header>
            
            <Modal.Body>
                <div style={{ 
                    marginLeft: 20, 
                    marginRight: 20, 
                    maxHeight: '60vh', 
                    overflowY: 'auto' 
                }}>
                    {list.length === 0 && !loading ? (
                        <div style={{ 
                            textAlign: 'center', 
                            padding: 40,
                            color: '#666'
                        }}>
                            <FaBuilding size={48} color="#ccc" style={{ marginBottom: 20 }} />
                            <Typography variant="body1">
                                Não existem contratos disponíveis
                            </Typography>
                        </div>
                    ) : (
                        list.map((item, index) => renderContractItem(item, index))
                    )}
                </div>
            </Modal.Body>
            
            <Modal.Footer>
                <div onClick={handleClose}>
                    <Button style={{ backgroundColor: "#a3a3a3" }} variant="contained">
                        Cancelar
                    </Button>
                </div>
                <div onClick={handleSave}>
                    <Button 
                        style={{ backgroundColor: "var(--main-bg-color)" }} 
                        variant="contained" 
                        disabled={loading}
                    >
                        Salvar
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
}

export default ModalEditarContratos;